import { Svg } from '../../../LegacyApp/client/components/svg/Svg';

const Icon = () => {
	return Svg({
		content: (
			<g>
				<circle cx="250" cy="250" r="250" fill="#2a5ada" />
				<g>
					<g>
						<path
							d="M250,50.03l-36.69,21.1-99.98,57.79-36.69,21.1v199.97l36.69,21.1,100.9,57.79,36.69,21.1,36.69-21.1,99.07-57.79,36.69-21.1v-199.97l-36.69-21.1-99.98-57.79-36.69-21.1ZM150.02,307.79v-115.58l99.98-57.79,99.98,57.79v115.58l-99.98,57.79-99.98-57.79Z"
							fill="#fff"
						/>
					</g>
				</g>
			</g>
		),
		width: 500,
		height: 500,
	});
};

export default Icon;
